export default "__VITE_ASSET__COak15v7__"